import React, { createContext, useContext, useEffect, useState } from "react";
import { DEFAULT_BUSINESS } from "@/lib/business";
import { applyAccent } from "@/lib/themes";

const AppSettingsContext = createContext(null);

const readLS = (k, d) => {
  try { const v = localStorage.getItem(k); return v == null ? d : v; } catch { return d; }
};
const readJSON = (k, d) => {
  try { const v = localStorage.getItem(k); return v ? { ...d, ...JSON.parse(v) } : d; } catch { return d; }
};

export function AppSettingsProvider({ children }) {
  const [currency, setCurrency] = useState(() => readLS("laser_calc_currency", "AUD"));
  const [dark, setDark] = useState(() => readLS("laser_calc_theme", "light") === "dark");
  const [accent, setAccent] = useState(() => (readLS("laser_calc_accent", "charcoal") === "sage" ? "charcoal" : readLS("laser_calc_accent", "charcoal")));
  const [business, setBusiness] = useState(() => readJSON("laser_calc_business", DEFAULT_BUSINESS));

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("laser_calc_theme", dark ? "dark" : "light");
  }, [dark]);

  useEffect(() => {
    applyAccent(accent);
    localStorage.setItem("laser_calc_accent", accent);
  }, [accent]);

  useEffect(() => { localStorage.setItem("laser_calc_currency", currency); }, [currency]);
  useEffect(() => { localStorage.setItem("laser_calc_business", JSON.stringify(business)); }, [business]);

  return (
    <AppSettingsContext.Provider value={{ currency, setCurrency, dark, setDark, accent, setAccent, business, setBusiness }}>
      {children}
    </AppSettingsContext.Provider>
  );
}

export function useAppSettings() {
  const ctx = useContext(AppSettingsContext);
  if (!ctx) throw new Error("useAppSettings must be used within AppSettingsProvider");
  return ctx;
}
